// Dependencies
// import Vue from 'vue'
import axios from 'axios'
window.axios = require('axios')
// import store from './store'
// import Vuelidate from 'vuelidate'
// import vuelidateErrorExtractor from 'vuelidate-error-extractor'
// import VueCookies from 'vue-cookies'
// import VueImageCompare from 'vue-image-compare'
// import './filters'
// import './forms'

import Alpine from 'alpinejs'


// import Buefy from 'buefy'
// Vue.use(Buefy, {
//   defaultIconPack: 'fas'
// })

// // Config
// Vue.use(Vuelidate)
// Vue.use(VueCookies)
// Vue.use(VueImageCompare)

// import FormGroup from './components/Forms/FormGroup.vue'

// Vue.use(vuelidateErrorExtractor, {
//   template: FormGroup,
//   messages: {
//     required: 'The field {attribute} is required',
//     email: 'Please provide a properly formatted email address',
//     phone: 'The {attribute} field is invalid',
//     minLength: 'This field must have at least {min} letters',
//     promoCode: 'The Promo Code field is invalid',
//   },
//   attributes: {
//     firstName: 'First name',
//     lastName: 'Last name',
//     fullName: 'Full name',
//     phone: 'Contact number',
//     message: 'Message',
//     emailAddress: 'Email address',
//     desiredDate: 'Desired date',
//     desiredTime: 'Desired time',
//     procedures: 'Procedures',
//     destination: 'Destination',
//   },
// })

// window.axios.defaults.headers.common = {
//   'X-Requested-With': 'XMLHttpRequest',
//   'Content-Type': 'application/json',
//   'x-api-key': process.env.MIX_FORMS_API_KEY,
// }

// // Components
// Vue.component('side-nav', require('./components/SideNav.vue').default)
// Vue.component('navbar-burger', require('./components/NavbarBurger.vue').default)
// Vue.component('Gallery', require('./components/GalleryLightbox.vue').default)
// Vue.component('StarRating', require('./components/StarRating.vue').default)
// Vue.component(
//   'SpecialityButton',
//   require('./components/Doctors/SpecialityButton.vue').default
// )
// Vue.component(
//   'SpecialityButtons',
//   require('./components/Doctors/SpecialityButtons.vue').default
// )
// Vue.component('Doctors', require('./components/Doctors/Doctors.vue').default)
// Vue.component('Counter', require('./components/Counter.vue').default)
// Vue.component('Deals', require('./components/Deals/Deals.vue').default)
// Vue.component(
//   'LocationButtons',
//   require('./components/Deals/LocationButtons.vue').default
// )
// // Vue.component(
// //   'CarrouselCertifications',
// //   require('./components/CarrouselCertifications.vue').default
// // )
// Vue.component(
//   'GlobalTopAlert',
//   require('./components/GlobalTopAlert.vue').default
// )
// Vue.component(
//   'ImageInclined',
//   require('./components/ImageInclined.vue').default
// )
// Vue.component('BeforeAfter', require('./components/BeforeAfter.vue').default)
// Vue.component('SocialBubble', require('./components/SocialBubble.vue').default)
// Vue.component('PopupForm', require('./components/PopupForm.vue').default)
// Vue.component(
//   'ExitIntentPopup',
//   require('./components/ExitIntentPopup.vue').default
// )

// // Vue Instance
// const app = new Vue({
//   el: '#app',
//   store,
//   // It's used to activate the global alert
//   mounted() {
//     const cookie = $cookies.get('alert')

//     if (!cookie) {
//       // setTimeout(() => {
//       store.dispatch('toggleAlert', true)
//       // }, 3000)
//     }
//   },
// })

import freeQuotes from './alpine-components/FreeQuote'
//import Doctors from './components-alpine/Doctors.js'

Alpine.data('counter', freeQuotes)
// Alpine.data('doctorsPage', Doctors)

// Starts alpine
window.Alpine = Alpine
Alpine.start();

